import { Box } from '@mui/material';
import React from 'react';
export const FiltersBarSurface = ({ children }) => {
    return React.createElement(Box, { p: 2 }, children);
};
